/* Deep links from the footer open the requested planning guide. */
(() => {
  function revealGuide() {
    const id = window.location.hash.slice(1);
    if (!id.startsWith('journal-')) return;
    const target = document.getElementById(id);
    if (!target || target.tagName !== 'DETAILS') return;
    target.open = true;
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  }
  window.addEventListener('hashchange', revealGuide);
  revealGuide();
})();
